export const splitStringByLength = (input: string, maxLength: number): string[] => {
  const words = (input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()).split(' ');
  const result = [];
  let currentLine = '';

  for (const word of words) {
    if (currentLine.length === 0) {
      currentLine = word;
    } else if ((currentLine + ' ' + word).length <= maxLength) {
      currentLine += ' ' + word;
    } else {
      result.push(currentLine);
      currentLine = word;
    }
  }

  if (currentLine) {
    result.push(currentLine);
  }

  return result;
};
